import exp from "constants"


export type ColumnType = {
  title: string,
  key: string,
  type: 'text' | 'number' | 'money' | 'date' | 'datetime' | 'boolean' | 'custom',
  options?: any,
  render?: (record: any) => JSX.Element,
  orderable?: boolean | undefined,
  style?: any,
  render_on_null?: boolean
}

export type ActionType = {
  title?: string,
  type: 'divider' | 'link',
  action?: string,
  textColor?: string,
  icon?: string,
  condition?: (record: any) => boolean
}

export type FilterType = {
  title: string,
  key: string,
  type: 'select' | 'ajaxselect' | 'date',
  options?: {
    data?: Array<any>,
    apiPath?: string,
    valueField: string,
    labelField: string,
    defaultValue?: any,
    addEmpty?: boolean,
    emptyLabel?: string
  }
}
const defaultAction = () => {


}

export const DefaultMenuActions: ActionType[] = [
  {
    title: 'GENERIC.EDIT',
    type: 'link',
    action: 'edit',
    icon: 'fa-solid fa-pencil'
  },
  {
    type: 'divider'
  },
  {
    title: 'GENERIC.DELETE',
    type: 'link',
    action: 'delete',
    textColor: 'danger',
    icon: 'fa-solid fa-trash'
  }
];

export const getBaseBarChartOptions = (params:any) => {
  return {
    series: [],
    drilldown: [],
    chart: { type: 'column', zoomType: 'x' },
    title: { text: params.title??'' },
    subtitle: {text: params.subtitle??''},
    xAxis: { type: 'category' },
    yAxis: {
      title: { text: params.yAxisTitle??'' },
      min: 0,
      type: 'linear',
    },
    legend: { enabled: false },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: { enabled: true, format: '{point.y:.0f}' },
      },
      columns: { minPointLength: 8 }
    },
    tooltip: {
      headerFormat: params.headerFormat??'<span style="font-size:11px">{series.name}</span><br>',
      pointFormat: params.pointFormat ?? '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.0f}</b><br/>',
      footerFormat: params.footerFormat??undefined,
      useHTML:params.useHTML??false,
      shared:params.shared??false
    },
    exporting: {
      enabled: true, sourceWidth: 900, buttons: {
        contextButton: {
          menuItems: params.menuItems??['downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG', 'downloadCSV']
        }
      }
    },

    credits: { enabled: false },
  }
}